module.exports = __webpack_public_path__ + "img/apple-watch-0.e7bae13f.png";